import moment from 'moment';

import Http from '@/support/http';
import S from '@/support/string';

const filteredResponse = (context, payload, response, updateState = false) => {

	let data = [];

	if (payload.onlyPending) {

		data = response.data.map((item) => {

			item.plans = item.plans.filter((plan) => plan.date === undefined);

			return item;

		});

	} else {
		data = response.data;
	}

	data = data.map((item) => {

		item.plans = item.plans.map((plan) => {

			plan.date = plan.date ? new Date(`${ plan.date }T00:00:00`) : null;

			return plan;

		});

		return item;

	});

	if (updateState) {
		context.commit('SET_SCHOOL_CLASS_LESSON_PLAN', data);
	}

	return data;

};

export default {
	state: {
		list: [],
		report: []
	},
	getters: {
		schoolClassLessonPlan: (state) => state.list
	},
	mutations: {
		SET_SCHOOL_CLASS_LESSON_PLAN(state, payload) {
			state.list = payload;
		},
		UDPATE_SCHOOL_CLASS_LESSON_PLAN(state, payload) {
			state.list[payload.parentIndex].plans[payload.index] = payload.value;
		}
	},
	actions: {
		clearSchoolClassLessonPlan(context) {

			context.commit('SET_SCHOOL_CLASS_LESSON_PLAN', {});
		},
		getSchoolClassLessonPlan(context, payload) {

			if (payload && payload.year && payload.theme && payload.class && payload.userId) {

				const route = `v1/school-class-lesson-plan/theme/${ payload.theme }/user/${ payload.userId }?year=${ payload.year }&class=${ payload.class }`;

				return Http.get(route).then((response) => filteredResponse(context, payload, response, true));

			}

		},
		updateSchoolClassLessonPlan(context, payload) {
			context.commit('UDPATE_SCHOOL_CLASS_LESSON_PLAN', payload);
		},
		putSchoolClassLessonPlan(context, payload) {

			if (payload && payload.schoolClassId && payload.themeId && payload.year && payload.userId) {

				const route = `v1/school-class-lesson-plan/school-class/${ payload.schoolClassId }/theme/${ payload.themeId }/year/${ payload.year }/user/${ payload.userId }`;

				return Http.put(route, payload.data.map((plan) => {

					plan.date = plan.date ? moment(plan.date).format('YYYY-MM-DD') : null;

					return plan;

				})).then((response) => filteredResponse(context, payload, response));

			}

		},
		getLessonReport(context, payload) {

			if (payload && payload.filter.schoolClassId && payload.filter.startDate && payload.filter.endDate) {

				const queryString = S.makeQueryString(payload.filter);

				return Http.get(`v1/school-class-lesson-plan/school-class/${ payload.filter.schoolClassId }/user/${ payload.userId }/report${ queryString }`).then((response) => {

					return response;

				});

			}
		},
		copySchoolClassLessonPlan(context, payload) {

			if (payload && payload.data && payload.themeId && payload.year && payload.userId) {

				const route = `v1/school-class-lesson-plan/theme/${ payload.themeId }/year/${ payload.year }/user/${ payload.userId }/copy`;

				return Http.post(route, payload.data).then((response) => {

					return response;

				});

			}

		},
	}
};



// WEBPACK FOOTER //
// ./sources/app/lesson-planning/store.js